import(/* webpackMode: "eager" */ "/codebuild/output/src1764240941/src/apps/web/app/[locale]/error.tsx");
